import {Injectable} from '@angular/core';
import environment from '../../environment/index.js';

@Injectable()
export class ImagesService {
  public getImageUrl(image, companyId, thumbnail: boolean = false) {
    let fileExtension = '';
    if (!image || !image.file_name || !image.image_name) {
      return '';
    }
    if (image.file_name) {
      fileExtension = image.file_name.split('.').pop();
    } else {
      fileExtension = image.image_name.split('.').pop();
    }
    const _thumbnail = thumbnail ? 'thumbnail' : 'image';
    const companyImageId = image.company_image_id || image.id;

    return `${environment.settings.cloudFrontUrl}${companyId}/${companyImageId}/${_thumbnail}.${fileExtension}`;
  }

  public getCategoryImageUrl(companyId, companyImageId, thumbnailUrl) {
    const fileExtension = thumbnailUrl.split('.').pop();
    return `${environment.settings.cloudFrontUrl}${companyId}/${companyImageId}/thumbnail.${fileExtension}`;
  }
}
